import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const PlaceRepository = {
  getPlaces: (name) => {
    return Axios({
      url: SETTINGS.API_URL + "place/filteredByName",
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        nameFilter: name,
      },
    });
  },
};
